import { useRef } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom';
import { useQueryClient, useQuery, useMutation } from 'react-query'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import { useLocation, editLocation, deleteLocation } from '../../../../data/Locations'
import { LocationSchema } from '../../../../data/Validation/LocationSchema';
import { FormikSelect } from '../../../Features/FormInputs/FormikSelect';

export const EditLocation = () => {
    const navigate = useNavigate()
    const queryClient = useQueryClient()
    const paramsObj = useParams()
    const locationId = paramsObj.id
    const formRef = useRef();

    const LocationQuery = useQuery({
        queryKey: ['locationId: ', locationId],
        queryFn: useLocation(locationId),
    })

    const { mutate: updateLocation, isLoading, isError, isSuccess } = useMutation(editLocation, {
        onSettled: ((data) => {
            queryClient.invalidateQueries('locations')
            queryClient.invalidateQueries(['locationId: ', locationId])
            navigate('../../')
        }),
        onError: ((error) => {
            alert("There was an error: ", error)
        })
    })

    const { mutate: trashLocation } = useMutation(deleteLocation, {
        onSettled: ((data) => {
            queryClient.invalidateQueries('locations')
            queryClient.invalidateQueries(['locationId: ', locationId])
            navigate('../../')
        }),
        onError: ((error) => {
            alert("There was an error: ", error)
        })
    })

    if (LocationQuery.isLoading) return "Loading...";
    if (LocationQuery.error) return "An error has occurred: " + LocationQuery.error.message;

    return (
        <div className="bg-white shadow rounded-lg divide-y divide-gray-200">
            <div className="bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
                <div className="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap">
                    <div className="ml-4 mt-2">
                        <h1 className="text-lg leading-6 font-large text-gray-900">
                            {LocationQuery.data.name}
                        </h1>
                    </div>
                </div>
            </div>
            <div className="flex flex-row">
                <div className="space-y-8 py-6 px-6 flex-1">
                    <div className="space-y-8">
                        <div className="mt-6">
                            <Formik
                                innerRef={formRef}
                                initialValues={{
                                    uid: locationId,
                                    name: LocationQuery.data.name,
                                    street: LocationQuery.data.street,
                                    city: LocationQuery.data.city,
                                    state: LocationQuery.data.state,
                                    zip: LocationQuery.data.zip,
                                    hours: LocationQuery.data.hours,
                                    phone: LocationQuery.data.phone,
                                    type: LocationQuery.data.type,
                                }}
                                validationSchema={LocationSchema}
                                onSubmit={(values, { setSubmitting }) => {
                                    updateLocation(values)
                                }}
                            >
                                {({ isSubmitting, errors, touched }) => (
                                    <Form>
                                        <div className="">
                                            <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                                                Location Name
                                            </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <Field type="text" name="name" id="name" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.name ? 'border-red' : ''}`} />
                                                <ErrorMessage name="name" component="div" className="text-red" />
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="street" className="block text-sm font-medium text-gray-700">
                                                Street Address
                                            </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <Field type="text" name="street" id="street" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.street ? 'border-red' : ''}`} />
                                                    <ErrorMessage name="street" component="div" className="text-red" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex flex-row space-x-6">
                                            <div className="">
                                                <label htmlFor="city" className="block text-sm font-medium text-gray-700">
                                                    City
                                                </label>
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <Field type="text" name="city" id="city" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.city ? 'border-red' : ''}`} />
                                                        <ErrorMessage name="city" component="div" className="text-red" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <label htmlFor="state" className="block text-sm font-medium text-gray-700">
                                                    State
                                                </label>
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <Field type="text" name="state" id="state" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.state ? 'border-red' : ''}`} />
                                                        <ErrorMessage name="state" component="div" className="text-red" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="">
                                                <label htmlFor="zip" className="block text-sm font-medium text-gray-700">
                                                    ZIP
                                                </label>
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <div className="mt-1 flex rounded-md shadow-sm">
                                                        <Field type="text" name="zip" id="zip" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.zip ? 'border-red' : ''}`} />
                                                        <ErrorMessage name="zip" component="div" className="text-red" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="zip" className="block text-sm font-medium text-gray-700">
                                                Hours
                                                </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <Field type="text" name="hours" id="hours" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.hours ? 'border-red' : ''}`} />
                                                    <ErrorMessage name="hours" component="div" className="text-red" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <label htmlFor="zip" className="block text-sm font-medium text-gray-700">
                                                Phone
                                                </label>
                                            <div className="mt-1 flex rounded-md shadow-sm">
                                                <div className="mt-1 flex rounded-md shadow-sm">
                                                    <Field type="text" name="phone" id="phone" className={`flex-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-r-md sm:text-sm text-black ${errors.phone ? 'border-red' : ''}`} />
                                                    <ErrorMessage name="phone" component="div" className="text-red" />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="">
                                            <FormikSelect label="Type: " name="type" className="mt-2">
                                                <option value="">Select a type</option>
                                                <option value="emergency">Emergency</option>
                                                <option value="shelter">Shelter</option>
                                                <option value="safeplace">Safe Place</option>
                                            </FormikSelect>
                                        </div>
                                        <button type="submit" className="relative inline-flex items-center my-6 px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-dkpurple hover:bg-ltpurple hover:text-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            {isLoading ? 'Updating location...' : isError ? 'Error!' : isSuccess ? 'Location Updated' : 'Save Changes'}
                                        </button>
                                        <button type="button" className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-black bg-mideoltblue hover:bg-ltpurple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            <Link to='../../'>Cancel Edit</Link>
                                        </button>
                                    </ Form>
                                )}
                            </ Formik>
                        </div>
                    </div>
                </div>
                <div className="ml-6 mt-12 mr-6 flex-shrink-0 flex flex-6 flex-col">
                    <button type="button" onClick={e => { trashLocation(formRef.current.values || null) }} className="relative inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-mideodkblue hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Archive Site
                    </button>
                </div>
            </div>
        </div >
    )
}